import { isApiError, apiGet, apiPost } from './apiClient';

export const lessonEnrollmentService = {
  async enrollStudent(
    lessonId: string,
    enrollmentData: {
      studentId: string;
      academyId: string;
      termId?: string | null;
      enrollmentScope?: 'full' | 'session';
      sessionDate?: string;
      sessionId?: string;
      sendBookingConfirmation?: boolean;
    }
  ): Promise<{ success: boolean; data?: { id: string }; error?: string }> {
    try {
      const payload: Record<string, unknown> = {
        studentId: enrollmentData.studentId,
        academyId: enrollmentData.academyId,
      };
      if (enrollmentData.sendBookingConfirmation === true) {
        payload.sendBookingConfirmation = true;
      }
      if (enrollmentData.termId != null && enrollmentData.termId !== '') {
        payload.termId = enrollmentData.termId;
      }
      if (enrollmentData.enrollmentScope != null) {
        payload.enrollmentScope = enrollmentData.enrollmentScope;
      }
      if (enrollmentData.sessionDate != null && enrollmentData.sessionDate !== '') {
        payload.sessionDate = enrollmentData.sessionDate;
      }
      if (enrollmentData.sessionId != null && enrollmentData.sessionId !== '') {
        payload.sessionId = enrollmentData.sessionId;
      }
      return await apiPost<{ id: string }>(`/lessons/${lessonId}/enroll`, payload);
    } catch (error: unknown) {
      console.error('Error enrolling student:', error);
      return {
        success: false,
        error: isApiError(error) ? error.message : error instanceof Error ? error.message : 'Failed to enroll student',
      };
    }
  },

  async getAvailableStudents(academyId: string): Promise<unknown[]> {
    try {
      const response = await apiGet<unknown[]>('/students', { params: { academyId } });
      return response?.data || [];
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  },
};
